// extracted by mini-css-extract-plugin
export default {"faqsWrapper":"faq_faqsWrapper__CdgCe","idVerificationFaq":"faq_idVerificationFaq__7pMGi"};